<template>
  <div class="wrap">
    <!-- <Nav :title="$t('loanRecord')" fixed safeAreaInsetTop placeholder left @leftClick="$router.push('/tabbar/goods')" /> -->
    <div class="wrap_logo">
      <img src="../../assets/new/login/logo.png" alt="">
    </div>
    <div class="wrap_title">{{ $t('欢迎') }}</div>
    <div class="content">
      <div class="apply_tips">
        <div class="tips_bank">
          <img src="../../assets/new/bank.png" alt="">
          <div class="tips_bank_right">
            <div class="right_title">{{ $t('贷款金额') }}</div>
            <!-- <div class="right_userphone">{{ $t('用户账号') }}:{{ userInfo.userphone }}</div> -->
          </div>
        </div>
        <div class="money">
          <div class="money_title">{{ $t('Balances') }}</div>
          <div class="money_num">{{ $money(userInfo.money || 0) }}</div>
        </div>
      </div>
      <div class="btns">
        <div class="btn" v-if="userInfo.auth_check > 0">
          <div class="btn_text">
            {{ $t('applying') }}
          </div>
        </div>
        <div class="btn" @click="confirm" v-if="userInfo.auth_level == 2">
          <div class="btn_text">
            {{ $t('提现') }}
          </div>
        </div>
        <div class="btn" @click="toService">
          <div class="btn_text">
            {{ $t('contactUs') }}
          </div>
        </div>
      </div>
      <div class="back" @click="back">
        {{ $t('返回') }}
      </div>
    </div>
    <van-overlay :show="show" @click="overlayChange" z-index="10" class="overlay">
      <div class="overlay_cont" @click.stop>
        <template v-if="flag === 1">
          <div class="cont_item">
            <div class="label">*{{ $t('提现金额') }}</div>
            <div class="value">
              <Field v-model="form.money" type="number" @input="inputChange" :placeholder="$t('请输入')" />
            </div>
          </div>
          <div class="cont_btn" @click="endClick1" :style="form.money ? {} : { opacity: .5 }">{{
            $t('user.Button.Two') }}</div>
        </template>
        <template v-else-if="flag === 2">
          <div class="cont_item">
            <div class="label">*{{ $t('提现账号') }}</div>
            <div class="value">
              <Field v-model="form.card" :placeholder="$t('请输入')" />
            </div>
          </div>
          <div class="cont_btn" @click="endClick" :style="form.card ? {} : { opacity: .5 }">{{
            $t('user.Button.Two') }}</div>
        </template>
        <template v-else-if="flag === 3">
          <div class="cont_item">
            <div class="label">*{{ $t('提现code') }}</div>
            <div class="value">
              <Field v-model="form.paypass" :placeholder="$t('请输入')" />
            </div>
          </div>
          <div class="cont_btn" @click="submit" :style="form.paypass ? {} : { opacity: .5 }">{{
            $t('user.Button.Two') }}</div>
        </template>
        <!-- <div class="cont_btn" @click="submit" :style="form.money && form.paypass && form.card ? {} : { opacity: .5 }">{{
          $t('user.Button.Two') }}</div> -->
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Icon, Overlay, Field, Toast } from "vant";
import { WITHDRAW } from "@/api"
import Nav from "@/components/Navbar";
import { mapGetters } from "vuex"
import RepeatClick from "@/utils/repeat"

const repeatClick = new RepeatClick();
export default {
  components: {
    [Icon.name]: Icon,
    Nav,
    [Overlay.name]: Overlay,
    Field,
    Toast
  },
  data() {
    return {
      show: false,
      flag: 1,
      form: {
        money: '',
        paypass: '',
        card: ''
      }
    }
  },
  created() {

  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    back() {
      this.$router.back()
    },
    overlayChange() {
      this.show = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.form = {
            money: '',
            paypass: '',
            card: ''
          }
          this.flag = 1;
        }, 1000)
      })
    },
    confirm() {
      if (this.userInfo.auth_level != 2) return;
      // this.$router.push('/new-withdraw')
      this.show = true
    },
    toService() {
      this.$api.toService();
    },
    inputChange(event) {
      if (Number(event) > Number(this.userInfo.money)) {
        this.form.money = Number(this.userInfo.money)
      }
    },
    endClick1() {
      if (!this.form.money) return;
      let flag = repeatClick.getIsClick();
      if (flag) return;
      repeatClick.setIsClick(true);
      this.show = false;
      this.flag = 2;
      this.show = true;
    },
    endClick() {
      if (!this.form.card) return;
      let flag = repeatClick.getIsClick();
      if (flag) return;
      repeatClick.setIsClick(true);
      this.show = false;
      this.flag = 3;
      this.show = true;
    },
    async submit() {
      if (!this.form.money || !this.form.paypass || !this.form.card) return;
      let flag = repeatClick.getIsClick();
      if (flag) return;
      repeatClick.setIsClick(true);
      try {
        const { ret, msg } = await WITHDRAW({ ...this.form });
        if (ret == 1) {
          Toast(msg)
          this.$store.dispatch('getUserInfo');
          this.overlayChange();
          return
        }
        Toast(msg);
      } catch (error) { }
    }
  },
  created() {
    this.$store.dispatch('getUserInfo')
  },
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background: var(--userBg) no-repeat;
  background-size: cover;
  position: relative;

  .wrap_logo {
    margin: calc(40rem / 16) calc(30rem / 16) 0;

    img {
      width: 65px;
      height: 65px;
      display: block;
    }
  }

  .wrap_title {
    margin: calc(10rem / 16) calc(30rem / 16) 0;
    font-size: 18px;
    color: var(--white);
    font-weight: bold;
  }

  .content {
    padding: 0 calc(30rem / 16);

    .apply_tips {
      background: var(--btnColor);
      color: var(--white);
      margin-top: calc(10rem / 16);
      border-radius: calc(20rem / 16);
      border: 2px solid var(--black);
      padding: calc(10rem / 16);

      .tips_bank {
        display: flex;
        align-items: center;

        img {
          width: 55px;
          height: auto;
          display: block;
        }

        &_right {
          margin-left: 5px;

          .right_title {
            text-transform: uppercase;
            font-size: 12px;
            color: var(--white);
            font-weight: bold;
          }

          .right_userphone {
            color: var(--white);
            font-size: 12px;
            font-weight: bold;
            margin-top: 10px;
          }
        }
      }

      .money {
        margin-top: 10px;
        color: var(--white);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .money_title {
          font-size: calc(12rem / 16);
          font-weight: 600;
          text-transform: uppercase;
        }

        .money_num {
          font-weight: bold;
          font-size: calc(14rem / 16);
        }
      }

      img {
        height: 150px;
        display: block;
      }
    }

    .btns {
      margin-top: calc(40rem / 16);
      // position: absolute;
      // width: calc(100% - 20px);
      // bottom: 50px;
      display: flex;
      gap: 20px;

      .btn {
        flex: 1;
        font-size: calc(16rem / 16);
        height: calc(40rem / 16);
        margin-top: calc(20rem / 16);
        border-radius: calc(10rem /16);
        background: linear-gradient(180deg, #0097b2, #474e55);
        color: var(--white);
        font-weight: 300;
        text-align: center;
        line-height: calc(40rem / 16);

        .btn_text {}
      }
    }

    .back {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 80px;
      width: 160px;
      margin: 0 auto;
      flex: 1;
      font-size: calc(16rem / 16);
      height: calc(40rem / 16);
      margin-top: calc(30rem / 16);
      border-radius: calc(10rem /16);
      background: linear-gradient(180deg, #0097b2, #474e55);
      color: var(--white);
      font-weight: 300;
      text-align: center;
      line-height: calc(40rem / 16);
    }
  }

  .overlay {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(84, 202, 199, .7) !important;

    &_cont {
      width: 85vw;
      padding: calc(16rem / 16) 10px 5px;
      border-radius: calc(10rem / 16);
      background: linear-gradient(180deg, #0097b2, #474e55);
      border: 2px solid var(--black);

      .cont_item {
        padding-bottom: 15px;

        .label {
          font-size: calc(16rem / 16);
          padding-bottom: 10px;
          font-weight: bold;
          color: var(--white);
        }

        .value {
          /deep/ .van-cell {
            border: 2px solid #cc0000;
            border-radius: 8px;
            line-height: 28px;
            padding: 0 16px;
            background: #e8e8e8;

            .van-field__control {
              color: var(--sizeColor);

              &::placeholder {
                color: #888 !important;
              }
            }
          }
        }
      }

      .cont_btn {
        width: fit-content;
        background: var(--white);
        color: #094aa0;
        border-radius: calc(4rem / 16);
        padding:5px 10px;
        font-weight: bold;
        font-size: 14px;
        text-align: center;
        margin: 0 auto;
        text-transform: uppercase;
        border: 1px solid var(--black);
      }
    }
  }
}
</style>